import React, {Component} from "react";
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {history} from "../../history/History";
import {sessionAddMulti} from "../../history/Session";
import InputMaterial from "../shared/InputMaterial";
import {NavLink} from "react-router-dom";
import {login, profile} from "../../utils/API"
import {set} from "../../redux/Action";
import Loading from "../shared/Loading";
import logo from "../../images/logo-white.png";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usernameEmail: '',
            password: '',
            loginApi: false,
            badLogin: undefined
        }
    }

    runAfterLoadSession = (func) => {
        if (window.sessionLoaded) {
            func()
        } else {
            setTimeout(() => {
                this.runAfterLoadSession(func)
            }, 300)
        }
    }

    componentDidMount() {
        this.runAfterLoadSession(() => {
            if (this.props.token) {
                history.push('/hom')
            }
        })
    }

    setUsernameEmail(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 64)
            return
        this.setState({
            usernameEmail: evt.target.value,
        })
    }

    setPassword(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 32)
            return
        this.setState({
            password: evt.target.value,
        })
    }

    login = () => {
        if (this.state.password.length < 4) {
            return
        }
        this.setState({loginApi: true})
        login(this.state.usernameEmail, this.state.password, (res) => {
            if (res === 'sendCode') {
                this.props.dispatch(set(Objects.sendCode, {
                    type: 'register',
                    username: this.state.usernameEmail,
                    email: this.state.usernameEmail,
                }))
                history.push("/hom/send-code")
                return
            }
            this.props.dispatch(set(Objects.token, res))
            profile((res2) => {
                this.props.dispatch(set(Objects.profile, res2))
                this.props.dispatch(set(Objects.tutorEnv, res2.tutor))
                let params = {
                    [Objects.token]: res,
                    [Objects.profile]: res2,
                    [Objects.tutorEnv]: res2.tutor,
                }
                this.setState({loginApi: false})
                sessionAddMulti(params)
                window.userLogin = true
                window.sessionLoaded = true
                history.push("/hom")
            })
        }, () => {
            this.setState({loginApi: false})
        })

    }

    render() {
        return (
            <div className="contain-app">
                <div className="title-login pt-5">
                    <h3>You are exactly where you need to be!</h3>
                </div>
                <div className="logo">
                    <img alt="logo" src={logo}/>
                </div>
                <div className="body-login">
                    <div>
                        <InputMaterial id="usernameEmail"
                                       valid={this.state.badLogin}
                                       value={this.state.usernameEmail}
                                       title="Username or Email"
                                       wrongMsg={"Username/Email or password incorrect"}
                                       onChange={(evt) => this.setUsernameEmail(evt)}
                        />
                        <InputMaterial id="password"
                                       type="password"
                                       valid={this.state.badLogin}
                                       value={this.state.password}
                                       title="Password"
                                       wrongMsg={"Username/Email or password incorrect"}
                                       onChange={(evt) => this.setPassword(evt)}
                        />
                        <div className="mt-3">
                            <button className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                    disabled={this.state.loginApi} onClick={this.login}>
                                <Loading show={this.state.loginApi}>
                                    <span>Login</span>
                                </Loading>
                            </button>
                        </div>
                        <div className="mt-5">
                            <span>Not register?</span>
                            <NavLink className="mt-2 waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                     to="/hom/register">Register</NavLink>
                        </div>
                        <div className="mt-4">
                            <span className="grey-text">Forgot your password?</span>
                            <NavLink className="white-text ml-1" to="/hom/forgot-password">Click Here</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.param[Objects.token],
        profile: state.param[Objects.profile],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
